export default __webpack_public_path__ + "static/media/circle-info-icon.158b9585.svg";